import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Option } from '@rivethealth/data/options';
import { ColumnSettings } from '@rivethealth/data/saved-view';
import { ObservableInput } from 'observable-input';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { ChangeService } from '../core/change.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'table-column-select',
  templateUrl: './table-column-select.component.html',
  providers: [ChangeService],
  styleUrls: ['./table-column-select.component.scss'],
})
export class TableColumnSelectComponent {
  constructor() {}

  ngOnInit() {}

  @Input()
  @ObservableInput()
  options!: Observable<Option[] | undefined>;

  @Input()
  @ObservableInput()
  tableName!: Observable<string>;

  @Input()
  @ObservableInput()
  fromStorage!: Observable<string[] | undefined>;

  @Input()
  @ObservableInput()
  pinned!: Observable<ColumnSettings[]>;

  @Output()
  onDragEvent = new EventEmitter<[number, number]>();

  @Output()
  onPinnedEvent = new EventEmitter<[string, boolean]>();

  readonly selectEvent = new Subject<string[]>();

  readonly allColumns: Observable<string[]> = this.options.pipe(
    filter(options => !!options),
    map(options => options!.map(o => o.id.toString())),
  );

  readonly defaultColumns: Observable<string[]> = combineLatest([
    this.fromStorage.pipe(filter(stored => !!stored)),
    this.allColumns,
  ]).pipe(map(([stored, all]) => (stored && stored.length > 0 ? stored : all)));

  @Output()
  selectedColumns: Observable<string[]> = combineLatest([
    this.defaultColumns,
    this.selectEvent.pipe(startWith(null)),
  ]).pipe(map(([defaults, event]) => event || defaults));
}
